import { Writable, writable } from 'svelte/store';
import type { AccountInfo } from '@azure/msal-browser';

export const isAuthenticated = writable(false);
export const authInitialized = writable<boolean>(false);
export const user = writable<AccountInfo | null>(null);

